import type { IPptPieChartOptions } from "app/services/PptExportService/PptExportServiceTypes";

export const getPieChartWidgetPptOptions = (): IPptPieChartOptions => {
    return {
        showLegend: true,
        showValuesOnChart: false,
    };
};
